import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/restore-snapshot/{snapshotId}']['PUT'];
type Input = ThisApi['params'];

const restoreQuestionnaireSnapshot = async ({ questionnaireId, snapshotId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/restore-snapshot/{snapshotId}', {
    questionnaireId,
    snapshotId,
  });
  const data = await formsBackendClient.put(path);
  return data.data;
};

export default restoreQuestionnaireSnapshot;
